import { render } from "./DropDownCustom.vue?vue&type=template&id=5ae416fe&scoped=true&ts=true"
import script from "./DropDownCustom.vue?vue&type=script&lang=ts"
export * from "./DropDownCustom.vue?vue&type=script&lang=ts"

import "./DropDownCustom.vue?vue&type=style&index=0&id=5ae416fe&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae416fe"]])

export default __exports__